<!--计算规则-->
<template>
  <div>
    <p class="dialog-form_head">计算规则：<span class="tips" v-if="showTips">(只在计费方式为"重量体积"时生效，所有配送平台统一规则)</span></p>
    <el-form-item label="起步价算法" prop="startPriceConfig" v-if="isDeliveryCancel">
      <el-select v-model="ruleForm.startPriceConfig" placeholder="请选择">
        <el-option v-for="item in algorithmSelect" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <p class="tips">
        <span v-show="ruleForm.startPriceConfig==0">取最高的起步价</span>
        <span v-show="ruleForm.startPriceConfig==1">含重货和抛货时，算2个起步价</span>
      </p>
    </el-form-item>
    <el-form-item label="最小计算单位" prop="smallestUnit">
      <el-radio  v-model="ruleForm.smallestUnit" :label="0">按件</el-radio>
      <el-radio  v-model="ruleForm.smallestUnit" :label="1">按箱(不足一箱算一箱)</el-radio>
    </el-form-item>
    <el-form-item :label="type == '吨' ? '重量体积计算规则' : '体积计算规则'" prop="smallestRule">
      <div class="section">
        <p><span>0~0.5(含0.5)</span> -- </p>
        <el-select v-model="ruleForm.smallestRule.a" placeholder="请选择">
          <el-option
            v-for="item in calRulesSelect"
            :key="item.code"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="section">
        <p><span>0.5~1(不含1)</span> -- </p>
        <el-select v-model="ruleForm.smallestRule.b" placeholder="请选择">
          <el-option
            v-for="item in calRulesSelect"
            :key="item.code"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="section">
        <p><span>≥1</span> -- </p>
        <el-select v-model="ruleForm.smallestRule.c" placeholder="请选择">
          <el-option label="按实际值算" :value="4"></el-option>
          <el-option label="零数按上两条规则计算" :value="5"></el-option>
        </el-select>
      </div>
    </el-form-item>
    <el-form-item label="零数累加规则" prop="isAcc">
      <el-radio  v-model="ruleForm.isAcc" :label="1">累加</el-radio>
      <el-radio  v-model="ruleForm.isAcc" :label="0">不累加</el-radio>
      <p class="tips">
        累加，指所有商品重量/体积累加后，再按重量体积计算规则计算<br>
        不累加，指各单品按重量体积计算规则计算，最后再合计
      </p>
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: ['ruleForm', 'type', 'showTips', 'isDeliveryCancel'],
  data () {
    return {

    }
  },
  mounted () {
  },
  methods: {

  },
  computed: {
    // 下拉框
    calRulesSelect () {
      let name = this.type === '立方/天' ? '立方' : '方/吨'

      return [
        {label: '不计费', value: 1},
        {label: `按0.5${name}算`, value: 2},
        {label: `按1${name}算`, value: 3},
        {label: '按实际值算', value: 4}
      ]
    },
    algorithmSelect () {
      return [
        {label: '只算一个起步价', value: 0},
        {label: '重货/抛货分开计算起步价', value: 1}
      ]
    }
  }
}
</script>

<style scoped>
  .dialog-form_head {
    font-size: 14px;
    background-color: rgba(161, 161, 161, 0.36);
    padding: 6px 0 6px 14px;
    margin-bottom: 14px;
    color: #484848;
  }
  .section {
    display: flex;
    max-width: 300px;
  }
  .section p {
    margin-right: 15px;
  }
  .section p span {
    width: 110px;
    display: inline-block;
    text-align: center;
  }
  .section  >>> .el-select {
    flex: 1;
  }
  .tips {
    color: #999;
    line-height: 15px;
    font-size: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/page/costConfigure/components/calculationRules.vue